import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { AcreditacionesComponent } from './components/acreditaciones/acreditaciones.component';
import { PasswordInicialComponent } from './components/password-inicial/password-inicial.component';
import { PasswordOlvidadoComponent } from './components/password-olvidado/password-olvidado.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { LayoutModule } from './layout/layout.module';
//import { PdfViewerModule} from 'ng2-pdf-viewer';
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    AcreditacionesComponent,
    PasswordInicialComponent,
    PasswordOlvidadoComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    LayoutModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    //PdfViewerModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
